var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.357 14 26.843 3.512a1.662 1.662 0 0 0 0-2.357 1.663 1.663 0 0 0-2.355 0L14 11.643 3.512 1.155a1.665 1.665 0 0 0-2.357 0 1.665 1.665 0 0 0 0 2.357L11.644 14 1.154 24.488a1.665 1.665 0 0 0 1.179 2.845c.426 0 .853-.163 1.178-.488L14 16.357l10.488 10.488a1.662 1.662 0 0 0 2.355 0 1.662 1.662 0 0 0 0-2.357L16.357 14Z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
};
export default SvgClose;